import { makeStyles } from '@material-ui/core/styles';
import { ChipProps } from '@material-ui/core/Chip/Chip';
import MDSChip, { IChipProps } from '@marqvision/mds/core/Chip';
import { IcoArrowDownOutline } from '@marqvision/mds/assets';
import { MDSTheme } from '@marqvision/mds/core';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
  },
}));

interface IOwnProps {
  color?: keyof typeof MDSTheme.palette;
  isSelect?: boolean;
}
// 아.. prop은 무엇인가..!!
type IProps = Omit<IChipProps, 'color'> & Omit<ChipProps, 'variant' | 'color' | 'size' | 'label'> & IOwnProps;

export const FilterChip = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { variant = 'tint', color = 'bluegray', isSelect, icon, size = 'medium', ...restProps } = props;

  return (
    <MDSChip
      variant={variant}
      color={color}
      size={size}
      icon={icon}
      endIcon={isSelect ? <IcoArrowDownOutline /> : undefined}
      classes={{
        root: classes.root,
      }}
      {...restProps}
    />
  );
};
